import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'

const path = '/le-connect/reports/hourly-checkins'
const method = 'get'

interface UseGetHourlyCheckinsReportParams {
  licensedEstablishmentId: number | undefined
  startDate: Date
  endDate: Date
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd')

export const useGetHourlyCheckinsReport = ({
  licensedEstablishmentId,
  startDate,
  endDate,
}: UseGetHourlyCheckinsReportParams) =>
  useApiQuery({
    path,
    method,
    queryKey: [
      path,
      licensedEstablishmentId,
      startDate.getTime(),
      endDate.getTime(),
    ],
    queryArgs: {
      licensedEstablishmentId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    },
  })
